import { createSelector } from '@reduxjs/toolkit';

import { VisualAppState } from '../../reducer';

const buildDetailsRoot = (state: VisualAppState) => state.apps.visual.buildDetails;

export const root = createSelector(buildDetailsRoot, (state) => state);
